import { AsyncValidatorFn, FormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { MatDateFormats, ThemePalette } from '@angular/material/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncFieldValidatorFn, FieldValidatorFn } from './field-validator-fn.model';
import { ISLAFormData } from './sla-form-data.model';
import { ISLAFormSuccess } from './sla-form-success.model';
import { ISLAFormWarn } from './sla-form-warn.model';

export enum FieldType {
    'text' = 'text',
    'mask' = 'mask',
    'date' = 'date',
    'daterange' = 'daterange',
    'select' = 'select',
    'number' = 'number',
    'decimal' = 'decimal',
    'textarea' = 'textarea',
    'dateTime' = 'dateTime',
    'checkbox' = 'checkbox',
    'tricheckbox' = 'tricheckbox',
    'multiselect' = 'multiselect',
    'password' = 'password',
}

export interface ISelectData<T> extends ISLAFormData {
    valueKey: string;
    options: BehaviorSubject<T[]> | Observable<T[]>;
    emptyString?: string;
    withoutEmptyString?: boolean;
    displaySearch?: boolean;
    autofocus?: boolean;
}

export interface ISearchSelectData<T> {
    key: string;
    selected: BehaviorSubject<T>;
    selectData: ISelectData<T>;
    displayWith?: (value: unknown, formControl: FormControl) => string;
    selectFunction?: (value: T, formGroup: UntypedFormGroup) => void;
}

export interface IDateOptions<T> {
    minDate?: T;
    maxDate?: T;
    dateClass?: MatCalendarCellClassFunction<T>;
    dateFilter?: (d: T | null) => boolean;
    dateFormats?: MatDateFormats;
}

export interface IField<T = unknown, D = unknown> {
    field: string;
    label: string;
    type: FieldType;
    dateOptions?: IDateOptions<D>;
    /** @deprecated use  dateOptions */
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    minDate?: Moment | Date | unknown;
    /** @deprecated use  dateOptions */
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    maxDate?: Moment | Date | unknown;
    color?: ThemePalette;
    mask?: string;
    unmask?: boolean;
    maskDefs?: Record<string, RegExp>;
    maskSlotChar?: string | number;
    decimalFormat?: string;
    thousandSeperator?: boolean;
    withClearButton?: boolean;
    taRows?: number;
    selectData?: ISelectData<T>;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    styleClass?: string;
    touch?: boolean;
    validatorFn?: (ValidatorFn | FieldValidatorFn)[];
    asyncValidatorFn?: (AsyncValidatorFn | AsyncFieldValidatorFn)[];
    success?: BehaviorSubject<ISLAFormSuccess>;
    warn?: BehaviorSubject<ISLAFormWarn>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectSearchData?: ISearchSelectData<any>;
}
